"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useEnrichAISlice = exports.useAppSelector = exports.useAppDispatch = void 0;
const react_redux_1 = require("react-redux");
// Typed hooks for enrich-ai code
const useAppDispatch = () => (0, react_redux_1.useDispatch)();
exports.useAppDispatch = useAppDispatch;
exports.useAppSelector = react_redux_1.useSelector;
// Convenience selector for enrichAI slice (LegacyRootState = enrichAI reducers only)
const useEnrichAISlice = (selector) => (0, react_redux_1.useSelector)((state) => selector(state));
exports.useEnrichAISlice = useEnrichAISlice;
